import React from 'react';
import ReactGA from 'react-ga4';
import MediaQuery from 'react-responsive'
import './Home4.scss'

const Home4 = ({sectionCurrently, positionCurrently, Section, Position, responsive}) => {

    const scroll = () =>{
        return sectionCurrently === Section.Section4 &&
                (positionCurrently === Position.TOP ||
                positionCurrently === Position.BOTTOM) &&
                !responsive
    }


    const mx = "fourth-body-section fade-slide-in-animation disposition-column justify-start align-center ";
    const md = "fourth-body-section-md fade-slide-in-animation disposition-column justify-start align-center ";
    const mt = "fourth-body-section-t fade-slide-in-animation disposition-column justify-center align-center ";
    const mm = "fourth-body-section-m fade-slide-in-animation disposition-column justify-center align-center";

    return (
        <>  
            <MediaQuery minWidth={1000}>
                <div className = { `${mx} ${scroll() ? "fade-out-animation" : ""}`}>
                    <div className = "fourth-body-elements disposition-column justify-center align-center">
                        <div className = "box-elements disposition-row justify-between align-center">
                            <div className = "box1 disposition-column justify-start align-start">
                                <img src = "assets/Home/Home4/banner1.png" className = "banner-1" alt = "Banner 1"></img>
                                <p className = "text-3">Redeemable in</p>
                                <div className = "icons-elements disposition-row justify-start align-center">
                                    <img src = "assets/Home/Home4/icon1.png" className = "icon-img" alt = "American Airlines"></img>
                                    <img src = "assets/Home/Home4/icon2.png" className = "icon-img" alt = "Copa Airlines"></img>
                                    <img src = "assets/Home/Home4/icon3.png" className = "icon-img" alt = "LifeMiles"></img>
                                    <img src = "assets/Home/Home4/icon4.png" className = "icon-img" alt = "Marriot"></img>
                                    <img src = "assets/Home/Home4/icon5.png" className = "icon-img" alt = "Hyatt"></img>
                                </div>
                            </div>
                            <div className = "box2 disposition-column justify-start align-start">
                                <img src = "assets/Home/Home4/banner2.png" className = "banner-1" alt = "Banner 1"></img>
                                <p className = "text-3">Priority pass included</p>
                                <div className = "icons-elements disposition-column justify-center align-start">
                                    <div className = "icon-elements disposition-row justify-between align-center">
                                        <img src = "assets/Home/Home2/stick.png" className = "stick-img" alt = "Icon"></img>
                                        <p className = "text-4">10 access per year</p>
                                    </div>
                                    <div className = "icon-elements disposition-row justify-between align-center">
                                        <img src = "assets/Home/Home2/stick.png" className = "stick-img" alt = "Icon"></img>
                                        <p className = "text-4">VIP Lounges access</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="first-row disposition-row justify-start align-start">
                            <div className = "description-section fade-slide-in-animation disposition-column justify-start align-start ">
                                <p className = "title-1">24/7<br/><b>WhatsApp Concierge</b></p>
                            </div>
                            <div className = "icons-elements disposition-row justify-between align-center">
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home4/icon-1-1.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Notification of all your spending and refunds</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home4/icon-1-3.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">A personalized assistant that learns from you and helps your with anything you need instantly</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home4/icon-1-2.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Dispute transactions in real-time</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home4/icon-1-4.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Works in any language you prefer</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MediaQuery>
            <MediaQuery maxWidth={1000}>
            <div className = { `${mm} ${scroll() ? "fade-out-animation" : ""}`}>
                    <div className = "fourth-body-elements disposition-column justify-center align-center">
                        <div className = "disposition-column justify-center align-center">
                            <div className = "box1 disposition-column justify-start align-start">
                                <img src = "assets/Home/Home4/banner1.png" className = "banner-1" alt = "Banner 1"></img>
                                <p className = "text-3">Redeemable in</p>
                                <div className = "icons-elements disposition-row justify-start align-center">
                                    <img src = "assets/Home/Home4/icon1.png" className = "icon-img" alt = "American Airlines"></img>
                                    <img src = "assets/Home/Home4/icon2.png" className = "icon-img" alt = "Copa Airlines"></img>
                                    <img src = "assets/Home/Home4/icon3.png" className = "icon-img" alt = "LifeMiles"></img>
                                    <img src = "assets/Home/Home4/icon4.png" className = "icon-img" alt = "Marriot"></img>
                                    <img src = "assets/Home/Home4/icon5.png" className = "icon-img" alt = "Hyatt"></img>
                                </div>
                            </div>
                            <div className = "box2 disposition-column justify-start align-start">
                                <img src = "assets/Home/Home4/banner2.png" className = "banner-1" alt = "Banner 1"></img>
                                <p className = "text-3">Priority pass included</p>
                                <div className = "icons-elements disposition-column justify-center align-start">
                                    <div className = "icon-elements disposition-row justify-between align-center">
                                        <img src = "assets/Home/Home2/stick.png" className = "stick-img" alt = "Icon"></img>
                                        <p className = "text-4">10 access per year</p>
                                    </div>
                                    <div className = "icon-elements disposition-row justify-between align-center">
                                        <img src = "assets/Home/Home2/stick.png" className = "stick-img" alt = "Icon"></img>
                                        <p className = "text-4">VIP Lounges access</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="first-row disposition-column justify-start align-center">
                            <div className = "description-section fade-slide-in-animation disposition-column justify-start align-start ">
                                <p className = "title-1">24/7<br/><b>WhatsApp Concierge</b></p>
                            </div>
                            <div className = "camel-section disposition-column justify-start align-center">
                                <img src = "assets/Home/Home4/img-camello.png" className = "camello-img" alt = "Camello"></img>
                                <div className = "icons-elements disposition-row justify-center align-center">
                                    <div className = "icon-element disposition-row justify-between align-center">
                                        <img src = "assets/Home/Home4/icon-1-1.png" className = "icon-img" alt = "icon"></img>
                                        <p className = "text-2">Notification of all your spending and refunds</p>
                                    </div>
                                    <MediaQuery maxWidth={750}><hr className = "line"></hr></MediaQuery>
                                    <div className = "icon-element disposition-row justify-between align-center">
                                        <img src = "assets/Home/Home4/icon-1-3.png" className = "icon-img" alt = "icon"></img>
                                        <p className = "text-2">A personalized assistant that learns from you and helps your with anything you need instantly</p>
                                    </div>
                                    <MediaQuery maxWidth={750}><hr className = "line"></hr></MediaQuery>
                                    <div className = "icon-element disposition-row justify-between align-center">
                                        <img src = "assets/Home/Home4/icon-1-2.png" className = "icon-img" alt = "icon"></img>
                                        <p className = "text-2">Dispute transactions in real-time</p>
                                    </div>
                                    <MediaQuery maxWidth={750}><hr className = "line"></hr></MediaQuery>
                                    <div className = "icon-element disposition-row justify-between align-center">
                                        <img src = "assets/Home/Home4/icon-1-4.png" className = "icon-img" alt = "icon"></img>
                                        <p className = "text-2">Works in any language you prefer</p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </MediaQuery>
        </>
    );
};

export default Home4;
